import { render, staticRenderFns } from "./adminslist.vue?vue&type=template&id=04eb0666&scoped=true&"
import script from "./adminslist.vue?vue&type=script&lang=js&"
export * from "./adminslist.vue?vue&type=script&lang=js&"
import style0 from "./adminslist.vue?vue&type=style&index=0&id=04eb0666&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04eb0666",
  null
  
)

export default component.exports